var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18432_16320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 18.3108C24.0662 18.9079 22.75 20.5836 22.75 22.1667C22.75 23.7498 24.0662 25.4254 26.25 26.0225V18.3108Z",
    fill: "#4B63C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75 29.9775V37.6892C31.9338 37.0921 33.25 35.4165 33.25 33.8334C33.25 32.2502 31.9338 30.5746 29.75 29.9775Z",
    fill: "#4B63C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 28C56 43.4638 43.4638 56 28 56C12.536 56 0 43.4638 0 28C0 12.536 12.536 0 28 0C43.4638 0 56 12.536 56 28ZM28 9.1C29.1598 9.1 30.1 10.0402 30.1 11.2V12.0868C34.6651 12.9043 38.5 16.3341 38.5 21C38.5 22.1598 37.5598 23.1 36.4 23.1C35.2402 23.1 34.3 22.1598 34.3 21C34.3 19.1003 32.7205 17.0895 30.1 16.3729V26.0868C34.6651 26.9044 38.5 30.3341 38.5 35C38.5 39.6659 34.6651 43.0956 30.1 43.9132V44.8C30.1 45.9598 29.1598 46.9 28 46.9C26.8402 46.9 25.9 45.9598 25.9 44.8V43.9132C21.3348 43.0956 17.5 39.6659 17.5 35C17.5 33.8402 18.4402 32.9 19.6 32.9C20.7598 32.9 21.7 33.8402 21.7 35C21.7 36.8998 23.2795 38.9105 25.9 39.627V29.9132C21.3348 29.0956 17.5 25.6659 17.5 21C17.5 16.3341 21.3348 12.9043 25.9 12.0868V11.2C25.9 10.0402 26.8402 9.1 28 9.1Z",
    fill: "#4B63C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18432_16320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPrice);
export default __webpack_public_path__ + "static/media/add-price.527a4109e096df084dd1590151905e93.svg";
export { ForwardRef as ReactComponent };